import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import Api from 'src/services/ApiService';
import { CommonAxiosResponse } from 'src/types';
import {
  CreateListingBundlePayload,
  CreateListingBundleResponse,
  UpdateListingBundlePayload,
  UpdateListingBundleResponse
} from './types';

export const createListingBundleThunk = createAsyncThunk<
  CommonAxiosResponse<CreateListingBundleResponse>,
  CreateListingBundlePayload,
  { state: RootState }
>('listing/createListingBundleThunk', async (data) => {
  const response = await Api.post('listing/bundle/create', data);
  return response;
});

export const updateListingBundleThunk = createAsyncThunk<
  CommonAxiosResponse<UpdateListingBundleResponse>,
  UpdateListingBundlePayload,
  { state: RootState }
>('listing/createListingBundleThunk', async (data) => {
  const { id, ...payload } = data;

  const response = await Api.patch(`listing/bundle/update/${id}`, payload);
  return response;
});
